import { NAME } from './constants';
import { router } from './router';

export const FakturacniProfil = {
	name: NAME,
	router,
};
